import {
    AddFavourites,
    AddFavouritesCallback,
    AddFavouritesContractModel,
    AddMultipleFavourites,
} from "@next/eventservice"
import {FavouritesApiPost} from "../../api/favourites"

const addFavouritesESB = new AddFavourites()
const addFavouritesCallbackESB = new AddFavouritesCallback()
const addMultipleFavouritesESB = new AddMultipleFavourites()

export const SubscribeToFavouritesAdd = (siteUrl: string) => {
    addFavouritesESB.subscribe(data => {
        LoadFavouritesApiData(siteUrl, data)
    })
}

export const SubscribeToFavouritesAddMultiple = (siteUrl: string) => {
    addMultipleFavouritesESB.subscribe(data => {
        LoadMultipleFavouritesApiData(siteUrl, data)
    })
}
class FavouritesAddApiModel {
    itemNumber = 0
    optionCode = ""
    itemUrl = ""
    linkedItemNumber = ""
    linkedOptionNo = ""
    listId = 0
}

const LoadFavouritesApiData = (url: string, data: AddFavouritesContractModel) => {
    const apiModel = new FavouritesAddApiModel()
    apiModel.itemNumber = data.itemNumber
    apiModel.optionCode = data.optionCode
    apiModel.itemUrl = data.itemUrl
    apiModel.linkedItemNumber = data.linkedItemNumber
    apiModel.linkedOptionNo = data.linkedOptionNo
    apiModel.listId = data.listId

    FavouritesApiPost(apiModel, `${url}/favourite`, addFavouritesCallbackESB, data.eventId)
}

export const LoadMultipleFavouritesApiData = (url: string, data: AddFavouritesContractModel[]) => {
    data.forEach(item => {
        LoadFavouritesApiData(url, item)
    })
}
